import { useTranslation } from 'react-i18next';
import { OrderClaimPrintoutData } from '../../../../types';
import { Space, Typography } from 'antd';
import { CLAIM_PRINT_DEFAULT } from '../../../../constants/printoutConstants';
import Table, { ColumnsType } from 'antd/lib/table';

type OrderClaimReasonSectionProps = {
  claim: OrderClaimPrintoutData;
};

type ClaimReasonTable = {
  index: number;
  claimReason: string;
  remark: string;
  amount: string;
};

const OrderClaimReasonSection = ({ claim }: OrderClaimReasonSectionProps) => {
  //General Components
  const { t } = useTranslation();

  const columns: ColumnsType<ClaimReasonTable> = [
    {
      title: (
        <Space
          size={0}
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Typography.Text style={{ fontSize: CLAIM_PRINT_DEFAULT }}>
            {`Index`}
          </Typography.Text>
        </Space>
      ),
      dataIndex: 'index',
      key: 'index',
      width: 50,
      render: (text: string) => (
        <div
          style={{
            textAlign: 'center',
            fontSize: CLAIM_PRINT_DEFAULT,
          }}
        >
          {text}
        </div>
      ),
    },

    {
      title: (
        <Space
          size={0}
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Typography.Text style={{ fontSize: CLAIM_PRINT_DEFAULT }}>
            {t('order.printoutComponents.claimReason')}
          </Typography.Text>
        </Space>
      ),
      dataIndex: 'claimReason',
      key: 'claimReason',
      width: 200,
      render: (text: string) => (
        <div
          style={{
            paddingLeft: 5,
            paddingRight: 5,
            fontSize: CLAIM_PRINT_DEFAULT,
          }}
        >
          {text}
        </div>
      ),
    },

    {
      title: (
        <Space
          size={0}
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Typography.Text style={{ fontSize: CLAIM_PRINT_DEFAULT }}>
            {t('order.printoutComponents.remark')}
          </Typography.Text>
        </Space>
      ),
      dataIndex: 'remark',
      key: 'remark',
      width: 150,
      render: (text: string) => (
        <div
          style={{
            paddingLeft: 5,
            paddingRight: 5,
            fontSize: CLAIM_PRINT_DEFAULT,
          }}
        >
          {text}
        </div>
      ),
    },
    {
      title: (
        <Space
          size={0}
          style={{
            width: '100%',
            flexDirection: 'row',
            justifyContent: 'center',
          }}
        >
          <Typography.Text style={{ fontSize: CLAIM_PRINT_DEFAULT }}>
            {t('order.printoutComponents.amount')}
          </Typography.Text>
        </Space>
      ),
      dataIndex: 'amount',
      key: 'amount',
      width: 50,
      render: (text: string) => (
        <div
          style={{
            textAlign: 'center',
            fontSize: CLAIM_PRINT_DEFAULT,
          }}
        >
          {text}
        </div>
      ),
    },
  ];
  return (
    <Table<ClaimReasonTable>
      className="tablePrintout"
      dataSource={[
        { index: 1, claimReason: claim.claimReason, remark: claim.remark, amount: claim.finalAmount },
      ]}
      rowKey={(data, index) => `${index}`}
      columns={columns}
      pagination={false}
      size="small"
      bordered={true}
      style={{
        marginBottom: 15,
      }}
    />
  );
};

export default OrderClaimReasonSection;
